import React from 'react';
import { Phone, MessageCircle, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { BRAND } from '../data/mock';
import { useQuote } from '../context/QuoteContext';
import SectionHeading from './SectionHeading';

const CTA = () => {
  const { openQuote } = useQuote();
  return (
    <section className="section-pad">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="relative rounded-[2.5rem] overflow-hidden bg-blush border border-pink-100 p-8 sm:p-12 md:p-16 shadow-soft">
          {/* Decorative blobs */}
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-pink-200/70 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-white/50 blur-3xl pointer-events-none" />

          <div className="relative text-center max-w-3xl mx-auto">
            <SectionHeading
              eyebrow="Ready to Celebrate?"
              title="Let's make your event"
              accent="unforgettable"
              subtitle="Join 1000+ wedding planners who trust Mr. Coconetto for a refreshing, personalized coconut experience."
            />

            <div className="mt-8 flex flex-wrap justify-center items-center gap-3">
              <Button
                onClick={() => openQuote({ source: 'cta-primary' })}
                className="bg-pink-brand hover:bg-[#BE185D] text-white rounded-full h-12 px-8 font-semibold shadow-pink-glow"
                data-testid="cta-request-quote-button"
              >
                <Sparkles className="w-4 h-4 mr-2" /> Request a Custom Quote
              </Button>
              <a
                href={`tel:${BRAND.phone}`}
                className="inline-flex items-center gap-2 rounded-full h-12 px-6 bg-white text-stone-900 border border-pink-200 hover:border-pink-300 font-semibold"
                data-testid="cta-call-link"
              >
                <Phone className="w-4 h-4 text-pink-brand" /> {BRAND.phone}
              </a>
              <a
                href={`https://wa.me/${BRAND.phoneRaw}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-full h-12 px-6 text-pink-brand hover:bg-white/60 font-semibold"
                data-testid="cta-whatsapp-link"
              >
                <MessageCircle className="w-4 h-4" /> WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
